import { ReactNode, useEffect } from 'react'
import CookieBar from '../organisms/CookieBar'
import Footer from '../organisms/Footer'
import HeaderBarEmployer from '../organisms/HeaderBarEmployer'

type Props = {
  children: ReactNode
  withFooter?: boolean
}

export default function WithEmployerHeaderLayout({
  children,
  withFooter = true,
}: Props) {
  return (
    <>
      <HeaderBarEmployer />
      {children}
      {withFooter && <Footer />}
      <CookieBar />
    </>
  )
}
